import * as React from 'react';
import TrackedBolResultModel from '../TrackedBolResultsModel';
import { Empty, Row, Col, Button, Checkbox, Tooltip, Icon } from 'antd';
import { TrackedBolSearchItem } from '.';
import { IAddTrackedBolRequestModel } from 'Core/Api/Kopp/Api';
import TrackedBolTermsConditionsLink from './TrackedBolTermsConditionsLink';
import { SubmitButton } from 'components/SubmitButton';

export interface Props {
  children?: React.ReactNode;
  results: IAddTrackedBolRequestModel[];
  addTrackedBol(): any;
  removeShipment: (shipment: IAddTrackedBolRequestModel) => void;
  onEditTrackedBol: (trackedBol: IAddTrackedBolRequestModel) => void;
}

export interface State {
  checked: boolean;
}

export default class TrackedBolSearchResults extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      checked: false,
    };
  }

  onChange = e => {
    console.log('checked = ', e.target.checked);
    this.setState({
      checked: e.target.checked,
    });
  };

  checkBoxText = (
    <>
      &nbsp;I accept the <TrackedBolTermsConditionsLink />
      &nbsp;and authorize Kingston Wharves Limited (“KWL”) to act on my behalf regarding all actions
      necessary to facilitate the clearance, declaration and payment of any Customs charges that may
      be applicable to Cargo (as defined in the Express Customs Client Agreement) on my behalf.
    </>
  );

  render() {
    return (
      <>
        {!this.props.results || this.props.results!.length <= 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            <Row>
              <Row style={{ fontWeight: 'bold', marginTop: 50 }}>
                <Col span={3}>
                  <p>BL No</p>
                </Col>
                <Col span={4}>
                  <p>Vessel Name</p>
                </Col>
                <Col span={3}>
                  <p>Arrival Date</p>
                </Col>
                <Col span={4}>
                  <p>Status</p>
                </Col>
                <Col span={4}>
                  <p>Service</p>
                </Col>
                <Col span={4}>
                  <p>Consignee Name</p>
                </Col>
                <Col span={1} />
                <Col span={1} />
              </Row>
              <Col span={24}>
                {this.props.results.map((trackedBol, key) => (
                  <TrackedBolSearchItem
                    onDeleteClicked={this.props.removeShipment}
                    trackedBol={trackedBol}
                    onEditClicked={this.props.onEditTrackedBol}
                  />
                ))}
              </Col>
            </Row>
            <Row style={{ marginTop: 10, marginBottom: 5, textAlign: 'justify' }}>
              <Checkbox checked={this.state.checked} onChange={this.onChange} />
              {this.state.checked ? (
                this.checkBoxText
              ) : (
                <>
                  {this.checkBoxText}&nbsp;
                  <Tooltip title="Please accept the Terms & Conditions">
                    <Icon style={{ color: 'red' }} type="info-circle" />
                  </Tooltip>
                </>
              )}
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col>
                {this.state.checked ? (
                  <SubmitButton
                    type="primary"
                    disabled={!this.state.checked}
                    onClick={this.props.addTrackedBol}>
                    Submit for Click N Collect Service
                  </SubmitButton>
                ) : (
                  <Tooltip title="Please accept the Terms & Conditions">
                    <SubmitButton
                      type="primary"
                      disabled={!this.state.checked}
                      onClick={this.props.addTrackedBol}>
                      Submit for Click N Collect Service
                    </SubmitButton>
                  </Tooltip>
                )}
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }
}
